export const sliceTwins = <ElType = unknown>(
  twins: Array<ElType>,
): ElType[][] => {
  if (twins.length === 0) {
    return [];
  }

  const copiedTwins = [...twins];
  while (copiedTwins.length < 26) {
    copiedTwins.push(...twins);
  }

  const slicedTwins: ElType[][] = [];
  const sliceSizes = [7, 6, 7, 6];

  for (const size of sliceSizes) {
    slicedTwins.push(copiedTwins.splice(0, size));
  }

  return slicedTwins;
};
